import { NonPersistedReport, ReportColumnType } from '@ardoq/api-types';
import { TrackEventFn, TrackingUserEventProvider } from './types';
import { ReportTemplate } from './reportTemplateTypes';
import { noop, pick } from 'lodash';
import {
  ReportTrackingEvents,
  splitDateRangeColumn,
} from '@ardoq/report-reader';
import { IconName } from '@ardoq/icons';
import { reportBuilderOperations } from './reportBuilderOperations';

export const reportTemplateToApiReport = (
  template: ReportTemplate
): NonPersistedReport => {
  return {
    ...pick(
      template,
      'datasource',
      'name',
      'description',
      'workspaceIds',
      'selectedAggregate',
      'aiPrompt'
    ),
    query: reportBuilderOperations.isAdvancedSearchBased(template)
      ? template.advancedSearchQuery
      : template.gremlinQuery,
    columns: reportBuilderOperations
      .getColumnsWithUpdatedNames(template)
      .flatMap(splitDateRangeColumn),
  };
};

type CreateReportUserEventTrackingFn = (
  subDomain: string,
  trackingEventFn?: TrackingUserEventProvider['trackingEventProvider']
) => TrackEventFn;

/**
 * Creates a function that tracks user events in the report builder.
 * And prepends the event with the domain name.
 *
 * Example: calling the function with subDomain = 'Sharing',
 * will create an event like: `Report Builder - Sharing0 opened share report modal`
 */
export const createReportUserEventTracking: CreateReportUserEventTrackingFn =
  (subDomain, trackingEventFn = noop): TrackEventFn =>
  <T extends object>(event: ReportTrackingEvents, meta?: T) =>
    trackingEventFn(`Report Builder - ${subDomain}0 ${event}`, meta);

export const getColumnIconNameByType = (type: ReportColumnType | null) => {
  return type === ReportColumnType.REFERENCE_TYPE_OUTGOING
    ? IconName.ARROW_FORWARD
    : type === ReportColumnType.REFERENCE_TYPE_INCOMING
      ? IconName.ARROW_BACK
      : undefined;
};
